<ul
  class="cabinet-menu"
  [ngClass]="{'menu-expand': show()}"
>
  @for (item of accountService.menuList(); track item.id) {
    <li class="cabinet-menu__item">
      <a
        class="cabinet-menu__item__link"
        [ngClass]="{'disabled': !item.active}"
        [routerLink]="item.active ? ['/cabinet', item.urlPath] : null"
        routerLinkActive="active"
        (click)="closeMenu()"
      >{{ item.title | translate }}</a>
    </li>
  }
  <li class="cabinet-menu__item display-md-none">
    <button class="cabinet-menu__item__button" type="button" (click)="showLogoutDialog()">
      <span>{{ 'logout' | translate }}</span>
      <img ngSrc="/images/icons/arrows/logout-black.svg" width="20" height="20" alt="">
    </button>
  </li>
</ul>

